import { z } from 'zod';
import type { IscEnrollmentStatusDto } from './iscEnrollmentStatus.dto';

/**
 * Request body for on-demand ISC activity-lapse sync + enrollment projection update.
 */
export const SyncIscActivityLapseRequestSchema = z
  .object({
    memberIds: z.array(z.string().uuid()).min(1),
  })
  .strict();

/** Inferred sync-request type. */
export type SyncIscActivityLapseRequestDto = z.infer<
  typeof SyncIscActivityLapseRequestSchema
>;

/**
 * Response after syncing activity timestamps / applying lapse onto enrollment projection.
 * Partial failures are reported in-band via `failedMemberIds` (HTTP 200).
 * `enrollmentStatuses` is aligned with `memberIds`; entries are `null` when the
 * member is missing or soft-deleted (status cannot be loaded).
 */
export type SyncIscActivityLapseResponseDto = {
  memberIds: string[];
  syncedMemberIds: string[];
  failedMemberIds: string[];
  lapsedMemberIds: string[];
  enrollmentStatuses: Array<IscEnrollmentStatusDto | null>;
};
